<template lang="pug">
  .sidebar(
    aria-modal="true"
  )
    .sidebar__header
      VBtn(
        fab
        color="white"
        plain
        @click="closeMenu"
      )
        span.vh Click to close Menu
        VIcon mdi-close
    nav.sidebar__nav(
      aria-label="Accessibility Navigation"
      role="navigation"
    )
      ul.nav__list
        li.nav__item(
          v-for="(item, index) in menu"
          :key="index"
        )
          IOSidebarMenuLink(
            :url="item.url"
            :title="item.title"
            :mobileTitle="item.mobileTitle"
            :isActive="isActive(item.url)"
            :is-mint-d-app="item.isMintDApp"
            :is-landing="item.isLanding"
          )
    .social__footer
      ul.sidebar__social
        li.social__item(
          v-for="item in social"
        )
          span.social__link(
            v-if="item.url === '#' || !item.url"
          )
            span.vh {{ item.title }}
            VIcon {{ item.icon }}
          a.social__link(
            v-else
            :href="item.url"
            target="_blank"
            rel="noopener nofollow"
          )
            span.vh {{ item.title }}
            VIcon {{ item.icon }}

</template>

<script>
import Social from '~/assets/data/social.json';
import Menu from '~/assets/data/menu.json';

export default {
  name: 'IOSidebar',
  components: {
    IOSidebarMenuLink: () => import('@/components/IOSidebarMenuLink'),
  },
  props: {
    isOpened: { type: Boolean, default: false },
    isSaleLive: { type: Boolean, default: false },
  },
  data() {
    return {
      social: Social,
      menu: Menu,
    };
  },
  methods: {
    isActive(url) {
      return url === this.$route.path;
    },
    closeMenu() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.sidebar {
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 600px;
  background: $purple;
  padding: 30px;
  user-select: none;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  transition: transform 0.5s cubic-bezier(0, 0, 0, 1);

  @include small-mobile {
    padding: 25px;
  }

  &.slide-left-enter,
  &.slide-left-leave-to {
    transform: translateX(100%);
  }
}

.sidebar__header {
  text-align: right;
}

.sidebar__nav {
  .nav__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav__item {
    display: block;
    position: relative;
    overflow: hidden;
    --ani-d: 0.1s;
    transition: transform 0.5s cubic-bezier(0, 0, 0, 1), opacity 0.3s ease-in;

    @include tall-mobile {
      margin: 10px 0;
    }

    .header.show-menu & {
      transition-delay: calc(var(--ani-d) * 1);

      &:nth-child(2) {
        transition-delay: calc(var(--ani-d) * 2);
      }

      &:nth-child(3) {
        transition-delay: calc(var(--ani-d) * 3);
      }

      &:nth-child(4) {
        transition-delay: calc(var(--ani-d) * 4);
      }

      &:nth-child(5) {
        transition-delay: calc(var(--ani-d) * 5);
      }

      &:nth-child(6) {
        transition-delay: calc(var(--ani-d) * 6);
      }

      &:nth-child(7) {
        transition-delay: calc(var(--ani-d) * 7);
      }

      &:nth-child(8) {
        transition-delay: calc(var(--ani-d) * 8);
      }

      &:nth-child(9) {
        transition-delay: calc(var(--ani-d) * 9);
      }
    }

    .header:not(.show-menu) & {
      transform: translateX(100%);
      opacity: 0;
      transition-delay: 0.5s;
    }
  }
}

.social__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 0 25px;

  @include mobile {
    padding: 0;
  }
}

ul.sidebar__social {
  list-style: none;
  padding: 0 !important;
  margin-top: auto;

  @include mobile {
    margin-left: auto;
  }

  .social__item {
    display: inline-block;
    position: relative;
    overflow: hidden;
    margin-right: 1.5rem;
  }

  .social__link {
    text-decoration: none;
    color: $white;

    .v-icon {
      color: $white;
      font-size: 1.5rem;

      @include mobile {
        font-size: 1.25rem;
      }
    }
  }

  span.social__link {
    opacity: 0.3;
  }
}
</style>
